import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Amplify } from 'aws-amplify';

import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterModule,
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.css',
})
export class AppComponent {
  title = 'Angular Ecommerce Dashboard | TailAdmin';

  constructor() {
    // Handle token handoff from the old site BEFORE Amplify.configure() so that tokens
    // are already in localStorage when the first Auth.currentSession() call is made by
    // AuthGuard. replaceState also sets the correct starting URL for the router's initial
    // navigation, avoiding a double redirect.
    this._handleTransfer();
    Amplify.configure(environment.cognitoConfiguration);
  }

  private _handleTransfer(): void {
    const hash = window.location.hash;
    if (!hash.startsWith('#transfer?')) return;

    const params = new URLSearchParams(hash.slice('#transfer?'.length));
    const idToken = params.get('idToken');
    const accessToken = params.get('accessToken');
    const refreshToken = params.get('refreshToken');
    const returnTo = params.get('returnTo') ?? '/';

    if (!idToken || !accessToken || !refreshToken) return;

    try {
      // Decode the idToken payload to get the Cognito username used in Amplify's storage keys.
      const base64 = idToken.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const payload = JSON.parse(atob(base64));
      const username: string = payload['cognito:username'] ?? payload.sub;
      const clientId = environment.cognitoConfiguration.Auth.Cognito.userPoolClientId;
      const prefix = `CognitoIdentityServiceProvider.${clientId}`;

      localStorage.setItem(`${prefix}.LastAuthUser`, username);
      localStorage.setItem(`${prefix}.${username}.idToken`, idToken);
      localStorage.setItem(`${prefix}.${username}.accessToken`, accessToken);
      localStorage.setItem(`${prefix}.${username}.refreshToken`, refreshToken);
      localStorage.setItem(`${prefix}.${username}.clockDrift`, '0');

      // Replace the URL so the router initialises directly at the target path, not the hash URL.
      history.replaceState(null, '', returnTo);
    } catch {
      // Malformed token — clear the hash and fall through to the normal login flow.
      history.replaceState(null, '', '/');
    }
  }
}
